module.exports = __webpack_public_path__ + "static/media/pattern-snow.89f53058.svg";